module.exports = __webpack_public_path__ + "assets/img/15_359_big.82f286e7.jpg";